export default __webpack_public_path__ + "static/media/course-bg.a4ae2548.png";